import styles from './table-tool-bar.module.scss';
import { GridApi } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import TableFilters from '../table-filters/table-filters';

import { InputAdornment, capitalize } from '@mui/material';

import TableDateSelection from '../focusTable/table-date-selection/table-date-selection';
import Icon from '../icon/icon';
import TextField from '../text-field/text-field';
import TableProductsFilter, { TableProductsFilterProps, iRelationProductGroups } from '../table-products-filter/table-products-filter';
import RefreshIcon from '@mui/icons-material/Refresh';
import IconButton from '../icon-button/icon-button';
import { CheckboxLabel, BaseTableProps, ToggleButton, ToggleButtonGroup, FocusTableProps } from '@frontend-workspace/react-shared-lib';

/* eslint-disable-next-line */
export interface TableToolBarProps extends FocusTableProps {
  gridApi: GridApi | null;
  setQuickFilter: (value: string) => void;
  quickFilter: string,
};

export function TableToolBar(props: TableToolBarProps) {
  const { t, i18n } = useTranslation();
  //const search = (e: any) => props.gridApi?.setQuickFilter(e.target.value);
  const search = (e: any) => props.setQuickFilter(e.target.value);
  if (props.headers.length === 0) return null;

  const getSelectAllText = (props: TableToolBarProps) => {
    const enabledField = props.headers?.find(cell => cell.cellRenderer?.name.includes('checkboxCellRenderer'))?.cellRendererParams.enabledField;
    const selectableCount = enabledField ? props.data.filter(data => data[enabledField]).length : props.data.length;
    if (selectableCount === props.data.length) {
      return t("simpleTable.selectAll")
    } else {
      return t("simpleTable.selectAllPossible", { maxCount: selectableCount })
    }
  };
  return (
    <Row className='mb-3'>
      {props.onSelectAll &&
        <Col xs="auto d-flex align-items-center">
          <CheckboxLabel
            checked={props.allSelected || false}
            disabled={false}
            onChange={(e) => { props.onSelectAll?.(); }}
            label={getSelectAllText(props)} />
        </Col>
      }
      {props.tableFilters &&
        <Col xs="auto d-flex align-items-end flex-wrap">
          <TableFilters switches={props.tableFilters} />
        </Col>
      }
      {props.productsFilter &&
        <Col xs="auto">
          <TableProductsFilter
            {...props.productsFilter}
          />
        </Col>
      }
      <Col className="ml-auto d-flex justify-content-end">
        {props.toggleFilters && <>
          <div className='d-flex flex-column'>
            <div><label>{t("simpleTable.show")}:</label></div>
            <div>
              <ToggleButtonGroup
                color="secondary"
                exclusive
                size="small"
                value={props.toggleFilters.value}
                onChange={(e, i) => {
                  if (i !== null) {
                    props.toggleFilters?.onChange?.(i);
                  }
                }}
                className='me-3'>
                {props.toggleFilters.values.map(val =>
                  <ToggleButton key={val} value={val} className='px-3'>{capitalize(val)}</ToggleButton>
                )}
              </ToggleButtonGroup>
            </div>
          </div>
        </>}
        {props.dateRange && <TableDateSelection
          dateRange={props.dateRange}
          onSetDateRange={props.onSetDateRange}
        />}
        {!props.disableSearch && <TextField
          type="search"
          onChange={search}
          value={props.quickFilter}
          label={t("simpleTable.search")}
          InputProps={{
            startAdornment:
              <InputAdornment position="start">
                <Icon>search</Icon>
              </InputAdornment>
          }} />
        }
        {props.onRefresh &&
          <IconButton onClick={props.onRefresh} className='d-flex align-items-end align-self-end ms-1'>
            <Icon>refresh</Icon>
          </IconButton>}
      </Col>
    </Row>
  )
}

export default TableToolBar;